import React, { memo } from 'react';
import classNames from 'classnames';
import { BUY_SELL_MAIN } from 'shared-modules/constants';
import PropTypes from 'prop-types';
import styles from './priceChart.module.scss';
import AutoSelectDetailChart from '../../../../AutoSelectDetails/components/AutoSelectDetailChart';
import { ItemButtons } from '../../../../../../../components';
import { ChartDescription } from '../../../../../../../screens/AutoSelect/components/ChartDescription';

const PriceChart = ({ selectedStrategy, strategyOptions }) => {
  const { strategyId, strategyDetail: { serviceId, instrumentId } = {} } = selectedStrategy || {};
  return (
    <div className={styles.chartArea}>
      <div className={styles.subtitleContainer}>
        <div className={styles.itemButtonsContainer}>
          <ItemButtons
            options={strategyOptions.items}
            activeId={strategyOptions.selected}
            onChange={strategyOptions.onChange}
          />
        </div>
        <ChartDescription className={styles.description} />
      </div>
      <div className={classNames(styles.chartContainer)}>
        {selectedStrategy && (
          <AutoSelectDetailChart
            key={serviceId}
            serviceId={serviceId}
            selectedInstrumentId={instrumentId}
            selectedStrategyId={strategyId}
            selectedSide={BUY_SELL_MAIN.BUY.CHART_ID}
            isOmakase
          />
        )}
      </div>
    </div>
  );
};

PriceChart.propTypes = {
  selectedStrategy: PropTypes.shape({
    strategyDetail: PropTypes.shape({
      serviceId: PropTypes.string.isRequired,
      instrumentId: PropTypes.string.isRequired,
    }).isRequired,
  }),
  strategyOptions: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([
          PropTypes.string,
          PropTypes.number,
          PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        ]),
        value: PropTypes.string,
        badge: PropTypes.string,
        disabled: PropTypes.bool,
        className: PropTypes.string,
      }),
    ).isRequired,
    selected: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    ]),
    onChange: PropTypes.func,
  }).isRequired,
};
PriceChart.defaultProps = {
  selectedStrategy: null,
};

export default memo(PriceChart);
